export default __webpack_public_path__ + "static/media/LightBlue0000.5c4c40e5.png";